module.exports = __webpack_public_path__ + "img/scott.0d50da8e.png";